import { create } from '@thoughtspot/logger';
const logger = create('web-storage');
const serializer = {
    serialize(item) {
        return JSON.stringify(item);
    },
    deserialize(data) {
        if (typeof data === 'number' || typeof data === 'boolean') {
            data = JSON.stringify(data);
        }
        if (!data) {
            return null;
        }
        try {
            return JSON.parse(data);
        }
        catch (error) {
            throw new Error(`Unable to parse. ${error}`);
        }
    },
};
export class WebStorage {
    constructor(storageType) {
        this.storageType = storageType;
        this.supported = this.isStorageSupported(window, storageType);
        this.storage = this.supported && window[storageType];
    }
    getItem(key) {
        if (this.throwIfUnsupported(this.supported)) {
            if (!key) {
                return null;
            }
            return serializer.deserialize(this.storage.getItem(key));
        }
        return null;
    }
    setItem(key, value) {
        if (this.throwIfUnsupported(this.supported)) {
            if (!key) {
                return;
            }
            this.storage.setItem(key, serializer.serialize(value));
        }
    }
    removeItem(key) {
        if (this.throwIfUnsupported(this.supported)) {
            if (!key) {
                return;
            }
            this.storage.removeItem(key);
        }
    }
    isStorageSupported(window, storageType) {
        let _storage;
        const test = 'test';
        try {
            _storage = window[storageType];
            _storage.setItem(test, test);
            _storage.removeItem(test);
            return true;
        }
        catch (error) {
            logger.log(`Webstorage of type ${storageType} is not supported.`, error);
            return false;
        }
    }
    throwIfUnsupported(supported) {
        if (!supported) {
            throw Error(`Unable to remove item from ${this.storageType}`);
        }
        return true;
    }
}
;
export let sessionStore;
export let localStore;
export async function initWebStorage() {
    sessionStore = new WebStorage('sessionStorage');
    localStore = new WebStorage('localStorage');
}
;
//# sourceMappingURL=web-storage.js.map